<!-- src/domains/spl-navegantes/views/ReportPasses.vue -->
<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import Select from "@/core/components/Select"
  import PassesReportList from "@/domains/spl-navegantes/partials/PassesReportList.vue"

  const UTF8_REGEX = /filename\*\s*=\s*UTF-8''([^;]+)/i
  const NOT_UTF8_REGEX = /filename\s*=\s*("?)([^";]+)\1/i
  export default {
    components: { Breadcrumbs, Select, PassesReportList },
    data() {
      const hoje = new Date()

      const formatDate = (data) => {
        const ano = data.getFullYear()
        const mes = String(data.getMonth() + 1).padStart(2, "0")
        const dia = String(data.getDate()).padStart(2, "0")
        return `${ano}-${mes}-${dia}`
      }

      const inicial = new Date(hoje)
      inicial.setFullYear(inicial.getFullYear() - 1)

      const final = new Date(hoje)

      return {
        title: "Relatório de Entregas de Passe",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "SPL Navegantes", path: "spl-navegantes.index" },
          {
            name: "Relatório de Entregas de Passe",
            path: "spl-navegantes.relatorios.passes",
          },
        ],

        pdfLoading: false,

        // filtros
        search: "",
        periodo_inicial: formatDate(inicial),
        periodo_final: formatDate(final),

        modalidade_id: "",
        modalidadeOptions: [
          { id: "", name: "" },
          { id: "1", name: "Pedestre" },
          { id: "2", name: "Ciclista" },
          { id: "3", name: "Motociclista" },
        ],

        categoria_id: "",
        categoriaOptions: [
          { id: "", name: "" },
          { id: "1", name: "Estudante" },
          { id: "2", name: "Trabalhador" },
          { id: "3", name: "Estagiário" },
        ],

        municipio_id: "",
        municipioOptions: [
          { id: "", name: "" },
          { id: "4540", name: "Itajaí" },
          { id: "4583", name: "Navegantes" },
        ],
      }
    },

    computed: {
      filters() {
        return {
          search: this.search,
          periodo_inicial: this.periodo_inicial,
          periodo_final: this.periodo_final,
          modalidade_id: this.modalidade_id,
          categoria_id: this.categoria_id,
          municipio_id: this.municipio_id,
        }
      },
    },

    mounted() {
      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`
    },

    methods: {
      async clearFilters() {
        const hoje = new Date()

        const formatDate = (data) => {
          const ano = data.getFullYear()
          const mes = String(data.getMonth() + 1).padStart(2, "0")
          const dia = String(data.getDate()).padStart(2, "0")
          return `${ano}-${mes}-${dia}`
        }

        const inicial = new Date(hoje)
        inicial.setFullYear(inicial.getFullYear() - 1)

        const final = new Date(hoje)

        this.search = ""
        this.periodo_inicial = formatDate(inicial)
        this.periodo_final = formatDate(final)
        this.modalidade_id = ""
        this.categoria_id = ""
        this.municipio_id = ""

        await this.$nextTick()
        this.$refs.list?.resetAndReload?.()
      },

      async submit() {
        await this.$nextTick()
        this.$refs.list?.resetAndReload?.()
      },

      buildReportPayload() {
        const f = this.filters || {}
        return {
          search: f.search ? String(f.search).trim() : null,
          filters: {
            categoria: f.categoria_id ? [String(f.categoria_id)] : [],
            modalidade: f.modalidade_id ? [String(f.modalidade_id)] : [],
            municipio: f.municipio_id ? [String(f.municipio_id)] : [],
            periodo_inicial: f.periodo_inicial || null,
            periodo_final: f.periodo_final || null,
          },
          // backend aceita, e você mantém padrão
          orderBy: { dtalteracao: "DESC" },
        }
      },

      getFilenameFromDisposition(disposition) {
        if (!disposition) {
          return null
        }

        const utf8Match = disposition.match(UTF8_REGEX)
        if (utf8Match?.[1]) {
          try {
            return decodeURIComponent(utf8Match[1].replace(/["']/g, ""))
          } catch (e) {
            return utf8Match[1].replace(/["']/g, "")
          }
        }

        const match = disposition.match(NOT_UTF8_REGEX)
        return match?.[2] ? match[2] : null
      },

      async blobToText(blob) {
        try {
          return await blob.text()
        } catch (e) {
          return "Erro ao processar resposta do servidor."
        }
      },

      forceDownloadBlob(blob, filename) {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.download = filename || "relatorio_passes.pdf"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },

      async gerarArquivo() {
        if (this.pdfLoading) {
          return
        }

        try {
          this.pdfLoading = true
          document.body.style.cursor = "wait"
          this.$Progress.start()

          const payload = this.buildReportPayload()

          const resp = await this.$axios.post(
            "/api/spl-navegantes/passes/relatorio/pdf",
            payload,
            {
              responseType: "blob",
              headers: { Accept: "application/pdf" },
              timeout: 0,
            }
          )

          const contentType =
            resp.headers?.["content-type"] ||
            resp.headers?.["Content-Type"] ||
            ""

          if (!String(contentType).toLowerCase().includes("application/pdf")) {
            const msg = await this.blobToText(resp.data)
            this.$toast?.error?.({ message: msg || "Erro ao gerar PDF." })
            return
          }

          const disposition =
            resp.headers?.["content-disposition"] ||
            resp.headers?.["Content-Disposition"]

          const filename =
            this.getFilenameFromDisposition(disposition) ||
            "relatorio_passes.pdf"

          this.forceDownloadBlob(resp.data, filename)
        } catch (e) {
          const data = e.response?.data
          if (data instanceof Blob) {
            const msg = await this.blobToText(data)
            this.$toast?.error?.({ message: msg || "Erro ao gerar PDF." })
          } else {
            this.$toast?.error?.({
              message: e.response?.data?.error || "Erro ao gerar PDF.",
            })
          }
        } finally {
          this.pdfLoading = false
          document.body.style.cursor = ""
          this.$Progress.finish()
        }
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div
      v-if="pdfLoading"
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="background: rgba(255,255,255,.75); cursor: wait;"
    >
      <div class="bg-white border rounded px-6 py-4 shadow">
        <div class="text-sm font-semibold">
          Relatório sendo gerado, aguarde...
        </div>
        <div class="text-xs text-gray-600 mt-1">
          Isso pode levar alguns minutos.
        </div>
      </div>
    </div>

    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-6" :crumbs="crumbs"/>

      <form
        @submit.prevent="submit"
        class="grid grid-cols-12 gap-x-6 gap-y-4 text-xs items-end"
      >
        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">BUSCA</label>
          <input
            v-model="search"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="text"
            placeholder="Nome/Matrícula"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">PERÍODO INICIAL</label>
          <input
            v-model="periodo_inicial"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="date"
            min="2000-01-01"
            max="2100-12-31"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">PERÍODO FINAL</label>
          <input
            v-model="periodo_final"
            :disabled="pdfLoading"
            class="pl-4 filter-search h-[38px]"
            type="date"
            min="2000-01-01"
            max="2100-12-31"
          >
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">MODALIDADE</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="modalidadeOptions"
            :selected.sync="modalidade_id"
          />
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">CATEGORIA</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="categoriaOptions"
            :selected.sync="categoria_id"
          />
        </div>

        <div class="col-span-12 md:col-span-3 flex flex-col row-gap-2">
          <label class="filter-label">MUNICÍPIO</label>
          <Select
            class="w-full"
            selectClass="form-select filter-select h-[38px]"
            :options="municipioOptions"
            :selected.sync="municipio_id"
          />
        </div>

        <div class="col-span-12 flex items-center justify-end gap-3 mt-1">
          <button
            type="button"
            class="btn-outline-green"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
            @click="gerarArquivo"
          >
            <span v-if="!pdfLoading">GERAR ARQUIVO</span>
            <span v-else>GERANDO...</span>
          </button>

          <button
            type="button"
            class="btn-outline-green"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
            @click="clearFilters"
          >
            LIMPAR FILTROS
          </button>

          <button
            type="submit"
            class="btn-green-solid"
            :disabled="pdfLoading"
            :class="{ 'opacity-60 cursor-not-allowed': pdfLoading }"
          >
            PESQUISAR
          </button>
        </div>
      </form>

      <div class="mt-6">
        <h2 class="text-sm font-medium text-green-light mb-2">
          RELATÓRIO DE ENTREGAS DE PASSE
        </h2>
        <PassesReportList ref="list" :filters="filters"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .btn-outline-green {
    border: 1px solid #16a34a;
    color: #16a34a;
    background: #fff;
    padding: 8px 14px;
    border-radius: 3px;
    font-weight: 600;
  }
  .btn-green-solid {
    border: 1px solid #16a34a;
    background: #16a34a;
    color: #fff;
    padding: 8px 18px;
    border-radius: 3px;
    font-weight: 700;
  }
</style>
